/**
 * A saved SDTM comparison from before version 6 kept at most 100 items and no
 * count beside them. One sitting exactly at that cap may be missing items, so
 * the screen must not read it as complete. Mirrors s3RecordMayBeIncomplete in
 * functions/src/verification/pipelineChecks.ts (keep the two in step).
 */
export const S3_CAP = 100;
export const S3_COUNTS_FROM_VERSION = 6;

export const S3_OLD_RECORD_NOTE =
  'The saved comparison of the data dictionary with the SDTM mapping is from an older version and may be missing items. Re-run Verification to see the full result.';

export function s3RecordNote(
  checksVersion: number | null | undefined,
  itemCount: number,
): string | null {
  const v = typeof checksVersion === 'number' ? checksVersion : 0;
  return v < S3_COUNTS_FROM_VERSION && itemCount >= S3_CAP ? S3_OLD_RECORD_NOTE : null;
}
